import Head from 'next/head';
import { ThemePage } from '@/components/themes/ThemePage';
import { ThemeInitiatives } from '@/components/themes/ThemeInitiatives';
import { ThemeEntities } from '@/components/themes/ThemeEmtities';

const UNIVERSITY_SUB_CATEGORIES = [
  {
    title: 'Campus Sampling',
    description:
      'Product drops and sampling stations across campus — libraries, student unions, common rooms, and lecture halls.',
  },
  {
    title: 'Club & Society Sponsorships',
    description:
      'Partner with student clubs, sports teams, and societies to get products in front of engaged communities.',
  },
  {
    title: 'Orientation & Welcome Week',
    description:
      'High-traffic brand activations during O-Week, freshers events, and new student orientations.',
  },
  {
    title: 'Study & Exam Fuel',
    description:
      'Energy, snacks, and wellness products distributed during study periods, exam weeks, and late-night library sessions.',
  },
  {
    title: 'Student Events & Socials',
    description:
      'Brand presence at student parties, cultural nights, fundraisers, and campus festivals.',
  },
  {
    title: 'Halls of Residence',
    description:
      'Product placements and activations in student accommodation common areas, kitchens, and social spaces.',
  },
];

export default function CampusThemePage() {
  return (
    <>
      <Head>
        <title>Universities | Sizzle</title>
        <meta
          name="description"
          content="Campus activations, student sampling, club sponsorships, and brand partnerships at colleges and universities."
        />
      </Head>
      <ThemePage
        breadcrumbs={[{ label: 'Themes', href: '/themes' }, { label: 'Universities' }]}
        title="Campus & Students"
        description="Reach the next generation of consumers where they live, study, and socialise. From O-Week activations to exam-week fuel drops, connect your brand with students across campuses."
        heroImage=""
        subCategoriesTitle="Built for every campus moment"
        subCategoriesSubtitle="Orientation, exams, club nights, halls — find the right moment to put your product in students' hands."
        subCategories={UNIVERSITY_SUB_CATEGORIES}
      >
        <ThemeInitiatives
          title="Featured Initiatives"
          subtitle="Active university and campus-related initiatives from brands and partners."
          categories={['trade']}
          limit={6}
          themes={['universities']}
        />

        <ThemeEntities
          title="Featured Brands and Businesses"
          roles={['brand', 'supplier']}
          limit={8}
          themes={['universities']}
        />
      </ThemePage>
    </>
  );
}
